import { CheckoutFormValues } from "@components/checkout/CheckoutFormContainer";
import { Product } from "@helpers/getProduct";
import { CouponState } from "@pages/checkout";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CheckoutInfoState {
  values: CheckoutFormValues | null;
  cartItems: Product[];
  coupon: CouponState | null;
  cartTotal: number | null;
  cartSubTotal: number | null;
  shippingPrice: string | null;
  orderValues: any | null;
  orderId: string | null;
}

const initialState: CheckoutInfoState = {
  values: null,
  cartItems: [],
  coupon: null,
  cartTotal: null,
  cartSubTotal: null,
  shippingPrice: null,
  orderValues: null,
  orderId: null,
};

const STORAGE_KEY = "checkout_info";

const checkoutInfo = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setOrderData: (state, action: PayloadAction<Partial<CheckoutInfoState>>) => {
      Object.assign(state, action.payload);
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...state, ...action.payload }));
    },
    loadOrderData: (state) => {
      const data = localStorage.getItem(STORAGE_KEY);

      if (data) {
        const parsed = JSON.parse(data);

        Object.assign(state, parsed);
      }
    },
    clearOrderData: (state) => {
      Object.assign(state, initialState);
      localStorage.removeItem(STORAGE_KEY);
    },
  },
});

export default checkoutInfo;
